import {
    Component,
    OnInit,
    ChangeDetectionStrategy,
    Inject,
    ViewChild,
    ChangeDetectorRef,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FileUploader } from 'ng2-file-upload';
import { environment } from 'src/environments/environment';
import { DocumentService } from 'src/app/acl-data/document/document.service';
import {
    mapPropertiesObj,
    deepCopy,
} from 'src/app/acl-data/general/generic.function';
import { FolderService } from 'src/app/acl-data/folder/folder.service';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-batch-upload',
    templateUrl: './batch-upload.component.html',
    styleUrls: ['./batch-upload.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BatchUploadComponent {
    @ViewChild('fileSelector', { static: true }) fileSelector;
    public uploader: FileUploader = new FileUploader({
        url: environment.batchUploadURL,
        isHTML5: true,
    });

    uploading = false;
    uploadFailed = false;
    filename = '';
    zipFile = false;
    constructor(
        public dialogRef: MatDialogRef<BatchUploadComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private cdr: ChangeDetectorRef,
        private folderService: FolderService
    ) {
        this.uploader.onBuildItemForm = (fileItem: any, form: FormData) => {
            try {
                const folder = deepCopy(this.data.folder);
                folder.propertiesObj.ObjectStore = this.data.objectStore;

                const folderFlat = mapPropertiesObj(folder);
                form.append('folder', JSON.stringify(folderFlat));
            } catch (e) {
                console.error('Error building Form', e);
                throw e;
            }
        };

        this.uploader.onAfterAddingFile = (fileItem: any) => {
            console.log('Added file:', fileItem);
            const isZipValue = fileItem.file.name
                .toLowerCase()
                .endsWith('.zip');
            this.filename = fileItem.file.name;
            const sizeValue = fileItem.file.size;
            // const file = this.fileSelector.nativeElement.files[0];

            this.zipFile = isZipValue;

            console.log(isZipValue, this.filename, sizeValue);
        };

        this.uploader.onSuccessItem = () => {
            const folder = this.data.folder;
            const objectStore = this.data.objectStore;
            window.location.reload(); //Make sure we reload all the folders, including sub folders
            //TODO: This should realy be a service call...

            // this.folderService
            //     .getByID(objectStore, folder.id, true)
            //     .pipe(take(1))
            //     .subscribe(v => this.dialogRef.close());
        };

        this.uploader.onErrorItem = () => {
            console.log('Failed');
            this.uploadFailed = true;
            this.uploading = false;
            this.uploader.clearQueue();
            this.cdr.detectChanges();
        };

        if (this.data.file) {
            console.log('We have a file');
            this.uploader.addToQueue([this.data.file]);
        }
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    upload() {
        this.uploading = true;
        this.uploader.uploadAll();
    }
}
